<script setup lang="ts">
import { useAppConfigStore } from '../stores/app-config-store';
import { useAppLayoutStateStore } from '../stores/app-layout-state';
import Button from 'primevue/button';
import { SidebarReceiver } from '@precon-tools-suite-by-shared/primevue-receivers';
import AppUserConfig from '../partials/AppUserConfig.vue';

const configStore = useAppConfigStore();
const stateStore = useAppLayoutStateStore();
</script>

<template>
    <Button
        v-if="configStore.floatingConfigToggle"
        class="layout-config-button p-link"
        style="cursor: pointer"
        @click="stateStore.toggleConfigSidebar()"
    >
        <i class="pi pi-cog" />
    </Button>

    <SidebarReceiver
        v-if="configStore.configEnabled"
        v-model:visible="stateStore.configSidebarVisible"
        position="right"
        class="layout-config-sidebar w-21rem"
        :partial="AppUserConfig"
    />
</template>
